<ng-container *ngIf="newsModel">
    <div class="d-flex flex-column gap-3 mt-2">
        <p class="h2 lh-1">{{ newsModel.title }}</p>
        <p class="fw-bold">{{ newsModel.preview }}</p>

        <markdown class="variable-binding markdown" [data]="newsModel.content"></markdown>
        <ng-container>
            <app-news-details-buttons [newsDetails]="newsModel"></app-news-details-buttons>
        </ng-container>
    </div>
</ng-container>